import React from 'react';

/**
 * UIFormField - Form Field molecule component
 */
const UIFormField = ({
    label = 'Label',
    placeholder = 'Enter value...',
    helperText = '',
    errorText = '',
    variant = 'default',
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    const errorColor = tokens?.colors?.find(c => c.name === 'error')?.value || '#ef4444';
    const hasError = variant === 'with-error' || errorText;

    // Get typography from tokens
    const labelTypo = tokens?.typography?.find(t => t.name === 'label')
        || tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 500, sizes: { mobile: 13, tablet: 13, desktop: 14 } };
    const bodyTypo = tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 14, tablet: 14, desktop: 14 } };

    const labelSize = labelTypo.sizes?.[deviceType] || labelTypo.sizes?.mobile || 13;
    const bodySize = bodyTypo.sizes?.[deviceType] || bodyTypo.sizes?.mobile || 14;
    const baseFontFamily = bodyTypo.fontFamily || 'Inter, system-ui, sans-serif';

    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            fontFamily: baseFontFamily
        }}>
            {/* Label */}
            <span style={{
                fontSize: labelSize,
                fontWeight: labelTypo.weight || 500,
                fontFamily: labelTypo.fontFamily || baseFontFamily,
                color: '#c9d1d9'
            }}>
                {label}
            </span>

            {/* Input */}
            <div style={{
                flex: 1,
                minHeight: 36,
                background: '#0d1117',
                border: `1px solid ${hasError ? errorColor : '#30363d'}`,
                borderRadius: 6,
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center'
            }}>
                <span style={{
                    color: '#484f58',
                    fontSize: bodySize,
                    fontFamily: baseFontFamily
                }}>
                    {placeholder}
                </span>
            </div>

            {/* Helper or Error text */}
            {(helperText || errorText) && (
                <span style={{
                    fontSize: labelSize - 2,
                    color: hasError ? errorColor : '#8b949e'
                }}>
                    {errorText || helperText}
                </span>
            )}
        </div>
    );
};

export default UIFormField;
